document.addEventListener('DOMContentLoaded', function () {
  var timers = document.querySelectorAll('[id^="CountdownTimer-"]');

  timers.forEach(function (timer) {
    var days = parseInt(timer.getAttribute('data-duration-days'), 10) || 0;
    var hours = parseInt(timer.getAttribute('data-duration-hours'), 10) || 0;
    var minutes = parseInt(timer.getAttribute('data-duration-minutes'), 10) || 0;
    var seconds = parseInt(timer.getAttribute('data-duration-seconds'), 10) || 0;

    var durationMs = (
      (days * 24 * 60 * 60) +
      (hours * 60 * 60) +
      (minutes * 60) +
      seconds
    ) * 1000;

    if (durationMs <= 0) {
      console.warn('Countdown timer: duration is 0, nothing to count down.');
      return;
    }

    // Fixed reference point (not tied to page load), so the loop
    // stays perfectly in sync across reloads and for every visitor.
    var referenceStart = new Date('2024-01-01T00:00:00Z').getTime();

    var daysEl = timer.querySelector('[data-unit="days"] .countdown-number');
    var hoursEl = timer.querySelector('[data-unit="hours"] .countdown-number');
    var minutesEl = timer.querySelector('[data-unit="minutes"] .countdown-number');
    var secondsEl = timer.querySelector('[data-unit="seconds"] .countdown-number');

    function pad(num) {
      return String(num).padStart(2, '0');
    }

    function update() {
      var now = new Date().getTime();
      var elapsed = now - referenceStart;

      // How far we are into the current cycle
      var elapsedInCycle = elapsed % durationMs;

      // Time remaining until this cycle ends and the next one begins
      var remaining = durationMs - elapsedInCycle;

      var d = Math.floor(remaining / (1000 * 60 * 60 * 24));
      var h = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var m = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      var s = Math.floor((remaining % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(d);
      if (hoursEl) hoursEl.textContent = pad(h);
      if (minutesEl) minutesEl.textContent = pad(m);
      if (secondsEl) secondsEl.textContent = pad(s);
    }

    update();
    setInterval(update, 1000);
  });
});